import { PrimitiveCard } from "./PrimitiveCard";

export default function ActionFieldsEditor({
  action,
  actionFields,
  primitive,
  className,
  density = "sm",
  showLabel = true,
  includeTitle = false,
}) {
  const fields = actionFields ?? action?.actionFields;
  if (!fields || Object.keys(fields).length === 0) {
    return null;
  }

  return (
    <div className={className}>
      <PrimitiveCard.Parameters
        primitive={primitive}
        activeParameters={fields}
        editable
        leftAlign
        fullList
        density={density}
        showLabel={showLabel}
        includeTitle={includeTitle}
      />
    </div>
  );
}
